export default __webpack_public_path__ + "static/media/3132 spice rack A side.2140fd4d.png";